import { Pipe, PipeTransform } from "@angular/core";
import { getValueAsString } from "@gtmhub/util";

@Pipe({ name: "cut" })
export class CutPipe implements PipeTransform {
  public transform(value: string | number, options: { wordwise: boolean; max: number; tail?: string }): string {
    let valueToCut = getValueAsString(value);

    if (!options.max || typeof options.max !== "number" || valueToCut.length <= options.max) {
      return valueToCut;
    }

    valueToCut = valueToCut.substring(0, options.max);
    if (options.wordwise) {
      let lastspace = valueToCut.lastIndexOf(" ");
      if (lastspace !== -1) {
        if (valueToCut.charAt(lastspace - 1) === ".") {
          lastspace = lastspace - 1;
        }
        valueToCut = valueToCut.substring(0, lastspace);
      }
    }

    return valueToCut + (options.tail || "...");
  }
}
